import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getResourceGroup = async () => {
	const response = await api.get('/grupoRecurso');
	return response.data;
};

export const useGetResourceGroup = () => {
	return useQuery(['resource-group-list'], getResourceGroup, {
		refetchOnWindowFocus: false,
	});
};
